// extracted by mini-css-extract-plugin
export default {"inputContainer":"DepartmentFilter-module__inputContainer__rz7Lm"};